export class AuthUser {
  username: string;
  companyId: number;
  firstName: string;
  lastName: string;
  email: string;
  countryCode: string;
  isAppUser: boolean;
  token: string;
  cityId?: number;
  phoneNumber: string;
}
